import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ValidationState, IExperimentList } from '@models';

import { RequestStatus } from '@store/types';

import Details from '../Details/Details';
import Validating from '../Validating/Validating';
import './NewExperimentList.scss';
export interface INewExperimentListStateProps
  extends Pick<
    IExperimentList,
    'file' | 'status' | 'errors' | 'experiment' | 'startUploadStatus'
  > {
  hasUploads: boolean;
}

export interface INewExperimentListDispatchProps {
  removeExperimentList: () => void;
  upload: () => void;
}

const NewExperimentList: React.FC<
  INewExperimentListStateProps & INewExperimentListDispatchProps
> = ({
  file,
  status,
  errors,
  removeExperimentList,
  experiment,
  upload,
  startUploadStatus,
  hasUploads,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`panel ${!hasUploads && 'last'}`}>
      <div className='close' onClick={() => removeExperimentList()}>
        <i className='fas fa-times'></i>
      </div>
      <div className='py-2 font-weight-bold'>
        {t('upload_validation_experimentListCheck')}: {file.name}
      </div>
      {status !== ValidationState.none && (
        <Validating
          validationStatus={status}
          errors={errors}
          upload={upload}
          uploading={startUploadStatus === RequestStatus.inProgress}
        />
      )}
      {!!experiment && <Details experiment={experiment} newExperiment={true} />}
    </div>
  );
};

export default NewExperimentList;
